import { jsx } from "react/jsx-runtime";
import { Box, Text } from "braid-design-system";
import omit from "lodash/omit.js";
import { generalLink } from "../EmployerFooter.css.mjs";
const NeedHelpLink = ({
  href,
  label,
  linkRenderer: LinkRenderer,
  ...restProps
}) => /* @__PURE__ */ jsx(
  Box,
  {
    display: ["block", "inline"],
    paddingTop: ["small", "none"],
    paddingBottom: ["medium", "xsmall"],
    children: /* @__PURE__ */ jsx(Text, { size: "small", weight: "medium", children: /* @__PURE__ */ jsx(
      LinkRenderer,
      {
        href,
        className: generalLink,
        ...omit(restProps, ["specificSite"]),
        children: label
      }
    ) })
  }
);
export {
  NeedHelpLink
};
